import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import type {ProductRoadmapEmbedConfigResponse} from 'client';
import {t} from 'i18next';

import {PaperRoadmapEmbed} from './PaperRoadmapEmbed';
import styles from './ProductRoadmap.module.css';

export const RoadmapDocumentEmbed = ({data}: {data: ProductRoadmapEmbedConfigResponse}) =>
  data.dropbox_embed_app_key ? (
    <PaperRoadmapEmbed appKey={data.dropbox_embed_app_key} url={data.open_url} title={data.title} />
  ) : data.iframe_url ? (
    <Box className={styles.productRoadmapEmbedFrameShell}>
      <iframe
        className={styles.productRoadmapEmbedFrame}
        data-testid="product-roadmap-iframe"
        title={data.title}
        src={data.iframe_url}
        loading="eager"
        referrerPolicy="no-referrer"
        allowFullScreen
      />
    </Box>
  ) : (
    <Box padding="24">
      <Text>{t('product_roadmap_open_source_document')}</Text>
    </Box>
  );
